import { FormattedMessage } from 'react-intl';

import { KTSVG } from '../../_metronic/helpers';
import Divider from '../utils/Divider';
import FilterBody from './FilterBody';
import FilterFooter from './FilterFooter';
import FilterHeader from './FilterHeader';

interface IFiltersProps<T> {
	filters: T[];
	sanitizeFilterOptionsValues: (param: Object) => Object;
	onApply: () => void;
	onReset: () => void;
	closeFilterDropdown: () => void;
}

const Filters = <T,>({ filters, sanitizeFilterOptionsValues, onApply, onReset, closeFilterDropdown }: IFiltersProps<T>) => {
	return (
		<>
			<FilterHeader>
				<div className="row row-cols-auto justify-content-between flex-nowrap gx-0">
					<div className="col-1 flex-grow-1">
						<FormattedMessage id="FILTERS.OPTIONS" defaultMessage="Filter Options" />
					</div>
					<div>
						<button className="bg-transparent border-0 m-0 p-0" onClick={closeFilterDropdown}>
							<KTSVG className="svg-icon-1" path="/media/icons/duotune/abstract/abs012.svg" />
						</button>
					</div>
				</div>
			</FilterHeader>

			<Divider className="mt-5" />

			<FilterBody filters={filters} onApply={onApply} sanitizeFilterOptionsValues={sanitizeFilterOptionsValues} />

			<FilterFooter onReset={onReset} />
		</>
	);
};

export default Filters;
